module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.r) ? _c('gmap-info-window', {
    attrs: {
      "options": _vm.infoWindowOptions,
      "position": _vm.r.geometry.location
    },
    on: {
      "closeclick": function($event) {
        _vm.$bus.$emit('toggleDetailedResult')
      }
    }
  }, [_c('div', {
    staticClass: "rp-iwin"
  }, [(!!_vm.r.name) ? _c('h3', [_vm._v(_vm._s(_vm.r.name))]) : _vm._e(), _vm._v(" "), (!!_vm.r.formatted_address) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Address: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_vm._v(_vm._s(_vm.r.formatted_address))])]) : _vm._e(), _vm._v(" "), (!!_vm.r.international_phone_number) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Phone number: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.r.international_phone_number
    }
  }, [_vm._v(_vm._s(_vm.r.international_phone_number))])])]) : _vm._e(), _vm._v(" "), (_vm.r.types) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Tags: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_vm._v(_vm._s(_vm._f("commedArray")(_vm.r.types)))])]) : _vm._e(), _vm._v(" "), (_vm.r.geometry.location) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_vm._v(_vm._s(_vm._f("latlng")(_vm.r.geometry.location)))])]) : _vm._e(), _vm._v(" "), (_vm.thumbs) ? _c('div', {
    staticClass: "rp-iwin-photos clearfix"
  }, _vm._l((_vm.thumbs), function(p) {
    return _c('a', {
      staticClass: "rp-iwin-photo",
      style: ({
        backgroundImage: 'url(' + p + ')'
      }),
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('img', {
      staticClass: "rp-iwin-photo-img",
      attrs: {
        "src": p
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "rp-iwin-actions"
  }, [_c('a', {
    staticClass: "rp-iwin-action btn btn-primary btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.addToProject()
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus"
  }), _vm._v(" Add to Map")]), _vm._v(" "), (!!_vm.r.url) ? _c('a', {
    staticClass: "rp-iwin-action",
    attrs: {
      "href": _vm.r.url,
      "target": "_blank"
    }
  }, [_vm._v("View on Google Maps")]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd326708"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/DetailedResult.vue
// module id = 484
// module chunks = 0